<template>
  <transition appear v-on:after-leave="onAfterLeave" duration="150">
    <div v-if="active" :class="[$style.wrapper, props.overflowHeight && $style.wrapperOverflowHeight]">
      <div :class="$style.scroll">
        <div :class="$style.backdrop" ref="backdrop" @click="onClickClose" />
        <div :class="containerClass" :style="containerStyle">
          <component
            v-if="props.raw"
            :is="contentComponent"
            v-bind="props.componentProps"
            :on-before-close="onBeforeClose"
          />
          <div v-else :class="modalClass">
            <h3 :class="$style.header" v-if="props.title">{{ props.title }}</h3>
            <button tabindex="-1" :class="$style.close" @click="reject">
              <app-icon name="XIcon" size="10" />
            </button>
            <div :class="$style.content">
              <component :is="contentComponent" v-bind="props.componentProps" :on-before-close="onBeforeClose" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name:  "Modal",
  props: [
    'index',
    'active',
    'resolve',
    'reject',
    'onBeforeClose',
    'onAfterClose',
    'result',
    'props',
    'options',

    // 'title', 'size', 'component', 'componentProps'
  ],
  data() {
    return {
      contentComponent: null,
    };
  },
  computed: {
    containerClass() {
      const { size } = this.props;
      let sizeClass = '';
      if (!size || typeof size === 'string') {
        sizeClass = this.$style[this.props.size] || this.$style.md;
      }
      return `${this.$style.container} ${sizeClass}`;
    },
    containerStyle() {
      const { size } = this.props;
      if (typeof size === 'number') return { width: size + 'px' };
      return null;
    },
    modalClass() {
      // const sizeClass = this.$style[this.props.size] || this.$style.md;
      // return `${this.$style.modal} ${sizeClass}`;
      return this.$style.modal;
    },
  },
  methods:  {
    onAfterLeave() {
      this.onAfterClose(this.index);
    },
    onClickClose( e ) {
      if (this.options.closeOnBackdrop === false) return;
      if (e.target === this.$refs.backdrop) this.reject();
      // this.$vuedals.close();
    },
    updateContentComponent() {
      if (typeof this.props.component === 'function') {
        this.props.component().then(( { default: contentComponent } ) => {
          this.contentComponent = contentComponent;
        });
      } else {
        this.contentComponent = this.props.component;
      }
    },
  },
  mounted() {
    this.updateContentComponent();
    this.$index = this.index;
  },
  watch: {
    component() {
      this.updateContentComponent();
    },
  },
};
</script>

<style lang="scss" module>
.wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  //overflow: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;

  &:global(.v-enter), &:global(.v-leave-to) {
    &:before {
      opacity: 0;
    }

    .container {
      opacity: 0;
      transform: translateY(-30px);
    }
  }

  &:global(.v-enter-to), &:global(.v-leave) {
    &:before {
      opacity: .5;
    }

    .container {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

.wrapperOverflowHeight {
  .scroll {
    height: 100%;
  }

  .container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .modal {
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .content {
    min-height: 0;
  }
}

.backdrop {
  position: absolute;
  //position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, .5);
  transition: all .1s ease-out;

  &:focus {
    outline: 0;
    //background: red;
  }
}

.scroll {
  position: relative;
  min-height: 100%;
  padding: 50px 0;
  //position: fixed;
  //top: 0;
  //left: 0;
  //right: 0;
  //bottom: 0;
  //overflow: auto;
  //pointer-events: none;
}

.container {
  pointer-events: none;
  margin: 0 auto 0;
  //padding: 50px 0;
  max-width: 100%;
  transition: all .15s ease-out;
  position: relative;

  > * {
    pointer-events: all;
  }
}

.containerOverflowHeight {

}

.xl {
  width: 1024px;
}

.lg {
  width: 850px;
}

.md {
  width: 650px;
}

.sm {
  width: 550px;
}

.xs {
  width: 350px;
}

.modal {
  margin: 0 10px;
  position: relative;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, .1);

  &:focus {
    outline: 1px solid #000;
  }
}

.header {
  border: 0;
  margin: 0;
  background: rgba(0, 0, 0, .05);
  border-radius: 5px;
  padding: 8px;
  padding-left: 12px;
  font-size: 1.2rem;
  transition: all .23s ease .1s;
  font-weight: 500;
  line-height: 1.2;
  color: rgba(var(--app-heading-color), 1);
}

.close {
  position: absolute;
  top: -6px;
  right: -8px;
  padding: 8px;
  background: #fff;
  width: 33px;
  height: 33px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, .1);
  border-radius: 5px;
  font-size: 1.25em;
  color: rgba(0, 0, 0, .6);
  cursor: pointer;
  border: 0;
  @include anim();

  &:hover {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, .1);
    transform: translate(-3px, 3px);
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.content {
  padding: 1rem;
}
</style>
